// removed by extract-text-webpack-plugin
module.exports = {"device-page-tile":"DevicePageTile__device-page-tile___2GVzP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DevicePage/DevicePageTile/DevicePageTile.css
// module id = 352
// module chunks = 0